'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n    height: 4px;\n    width: 60px;\n    background-color: ', ';\n    margin-bottom: 15px;\n\tmargin-top: ', 'px;\n\tmargin-bottom: ', 'px;\n\tmargin-left: ', 'px;\n\tmargin-right: ', 'px;\n'], ['\n    height: 4px;\n    width: 60px;\n    background-color: ', ';\n    margin-bottom: 15px;\n\tmargin-top: ', 'px;\n\tmargin-bottom: ', 'px;\n\tmargin-left: ', 'px;\n\tmargin-right: ', 'px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styles = require('../link/styles');

var _sizes = require('../../constants/sizes');

var _getSize = require('../../helpers/getSize');

var _getSize2 = _interopRequireDefault(_getSize);

var _colors = require('../../constants/colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Checkmark = function Checkmark(props) {
	return _react2.default.createElement(
		'svg',
		props,
		_react2.default.createElement('path', {
			d: 'M14.712.287a.99.99 0 0 0-1.394 0L5.006 8.6 1.681 5.274a.99.99 0 0 0-1.394 0 .99.99 0 0 0 0 1.394l3.981 3.981a.978.978 0 0 0 .332.217.98.98 0 0 0 1.113-.186l9-8.998a.99.99 0 0 0 0-1.395',
			fill: '#FFF',
			fillRule: 'evenodd'
		})
	);
};

Checkmark.defaultProps = {
	width: '15',
	height: '11',
	viewBox: '0 0 15 11',
	xmlns: 'http://www.w3.org/2000/svg'
};


var DividerComponent = _styledComponents2.default.div(_templateObject, function (_ref) {
	var color = _ref.color;
	return color && color;
}, function (_ref2) {
	var top = _ref2.top;
	return (0, _getSize2.default)(top);
}, function (_ref3) {
	var bottom = _ref3.bottom;
	return (0, _getSize2.default)(bottom) + 15;
}, function (_ref4) {
	var left = _ref4.left;
	return (0, _getSize2.default)(left);
}, function (_ref5) {
	var right = _ref5.right;
	return (0, _getSize2.default)(right);
});

var Divider = function (_React$Component) {
	_inherits(Divider, _React$Component);

	function Divider() {
		_classCallCheck(this, Divider);

		return _possibleConstructorReturn(this, (Divider.__proto__ || Object.getPrototypeOf(Divider)).apply(this, arguments));
	}

	_createClass(Divider, [{
		key: 'render',
		value: function render() {
			var color = this.props.color || _colors.Colors.Primary;
			return _react2.default.createElement(DividerComponent, {
				top: this.props.top,
				bottom: this.props.bottom,
				left: this.props.left,
				right: this.props.right,
				color: color
			});
		}
	}]);

	return Divider;
}(_react2.default.Component);

exports.default = Divider;